export default __webpack_public_path__ + "static/media/profilepic1.7b394c39.png";